import { usePanel } from "@/providers/PanelProvider";
import { useEffect } from "react";
import { PageFrame } from "@/components/layout/PageFrame";
import { OverviewPage } from "@/modules/overview/components/OverviewPage";

export function OverviewRoute() {
  const { clients, instances, stats, selectedClient, openDeliveryForClient, changePage, isDataLoading, refreshData, setSelectedClientId } = usePanel();
  useEffect(() => {
    const intervalId = window.setInterval(() => { void refreshData(); }, 30000);
    return () => window.clearInterval(intervalId);
  }, [refreshData]);
  const handleClientSelect = (clientId: string) => {
    setSelectedClientId(clientId);
    changePage("instances");
  };

  return <PageFrame><OverviewPage clients={clients} instances={instances} stats={stats} selectedClient={selectedClient} onSelectClient={handleClientSelect} onDeploy={openDeliveryForClient} onNavigate={changePage} isLoading={isDataLoading} /></PageFrame>;
}

export default OverviewRoute;
